import { configureStore } from '@reduxjs/toolkit';
import partnerReducers from './slice/partnersSlice';
import presetReducers from './slice/presetSlice';
import moduleReducers from './slice/moduleSlice';
import userReducers from './slice/userSlice';
import sessionReducers from './slice/sessionSlice';
import gitReportReducers from './slice/gitReportSlice';
import repoOwnerReducers from './slice/repoOwnerSlice';

export const store = configureStore({
  reducer: {
    session: sessionReducers,
    partners: partnerReducers,
    presets: presetReducers,
    modules: moduleReducers,
    users: userReducers,
    gitReport: gitReportReducers,
    repoOwners: repoOwnerReducers
  }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
